import { toastr } from 'react-redux-toastr';
import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';

export const UPDATE_POOLED_RATES_REQUEST = 'UPDATE_POOLED_RATES_REQUEST';
export const UPDATE_POOLED_RATES_SUCCESS = 'UPDATE_POOLED_RATES_SUCCESS';
export const UPDATE_POOLED_RATES_FAILURE = 'UPDATE_POOLED_RATES_FAILURE';

function requestUpdatePooledRates() {
  return {
    type: UPDATE_POOLED_RATES_REQUEST,

  };
}

function receiveUpdatePooledRates(structure, validationResult, topAccount) {
  return {
    type: UPDATE_POOLED_RATES_SUCCESS,
    structure,
    validationResult,
    topAccount
  };
}

function rejectUpdatePooledRates() {
  return {
    type: UPDATE_POOLED_RATES_FAILURE,
  };
}

export function updatePooledRates(accountId, accountName, rates) {
  return (dispatch) => {
    dispatch(requestUpdatePooledRates());
    const promise = () => ApiService
      .updatePooledRates(accountId, accountName, rates)
      .then((response) => {
        dispatch(receiveUpdatePooledRates(response.data.structure, response.data.validationResult, response.data.topAccount));
        if (Object.prototype.hasOwnProperty.call(response.data, 'structure')) {
          toastr.success('Save Successful', 'Update pooled rates was successful');
        } else {
          toastr.error('Save Failed', 'There was an unexpected response when trying to save the changes');
        }
      })
      .catch(error => dispatch(handleException(error, () => dispatch(rejectUpdatePooledRates()), true)));

    return promise();
  };
}
